import { createSlice } from "@reduxjs/toolkit";
import { controlState } from "../intialStates/shared";
import { controls_booking_actions, controls_layout_actions } from "../actions/controls";
export type controllSliceType = {
  control:{
    calenderBookingType:string
    sortingBy:{
      column:string,
      order:string
    }
  }
}
const controlSlice = createSlice({
  name: "control",
  initialState: {
     ...controlState
  },
  reducers: {
    ...controls_layout_actions,
  }
})
export const {openShareModel,setInviteLink,closeShareModel,updatePathQueue,closeSideBar,openSideBar,setCalenderBookingType,changeViewMode,resetNewReadedMsgs,updateNewReadedMsgs,setDragElementInfo,updateGeneralModelInfo,resetGeneralModelInfo,closeGeneralModelInfo,toggleSystemModel,setSortingOption,storeWindowPathname,resetHomeSidebarInfo,updateHomeSidebarInfo,toggleDateInputPortal,setFilter,resetFilter } = controlSlice.actions
export default controlSlice.reducer